module.exports = __webpack_public_path__ + "media/images/banner/klook/pc/rental-o_770_280_ko-d481a98b447326c410bda4c9757f2e9e.jpg";